import { Package } from '../package/package.type';

export const checkUserHasSlot = async () => {
  const res = await apiClient().get<Package>('/ecom-users/user-has-slot-listing');

  return res.data;
};
